module.exports = __webpack_public_path__ + "img/logo.d9909a26.png";